import { NotificationSocketRepository } from "../repositories/NotificationSocketRepository";

export class OnPurchaseMessageNotification {
	constructor(private repository: NotificationSocketRepository) {}

	execute(callback: (data: number) => void): void {
		return this.repository.onPurchaseMessageNotification(callback);
	}
}
